import {createSmartAction} from 'redux-smart-actions';

export const getRecipes = createSmartAction(() => ({
  request: {
    url: '/mco-leclub-api/v1/post/recette-heading',
  },
}));

export const getCircleRecipeList = createSmartAction(() => ({
  request: {
    url: '/wp/v2/categories?hide_empty=true',
  },
}));

export const getConseilsByPage = createSmartAction(({page}) => {
  const per_page = 2;
  const offset = (page - 1) * per_page;
  return {
    request: {
      url: `/wp/v2/conseils?per_page=${per_page}&offset=${offset}`,
    },
    meta: {requestKey: `/${page}`},
  };
});

export const getRecipesByCategoryAndPage = createSmartAction(({page, categoryId}) => {
  const per_page = 4;
  const offset = (page - 1) * per_page;
  return {
    request: {
      url: `/wp/v2/recette_club?per_page=${per_page}&offset=${offset}${
        categoryId ? `&categories=${categoryId}` : ''
      }`,
    },
    meta: {requestKey: `/${page}${categoryId ? `/category=${categoryId}` : ''}`},
  };
});
